
import {fromEvent as observableFromEvent, merge, Observable, Subject, Subscription} from 'rxjs';

import {mergeMap, map, filter, takeUntil, tap, debounceTime, switchMap} from 'rxjs/operators';
/**
 * Created by eladd on 7/13/2017.
 */
import {Directive, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output} from "@angular/core";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {DeltaEvent} from "./deta.event";

export  {DeltaEvent} from "./deta.event";

@UntilDestroy()
@Directive({
	selector: '[cpDeltaDrag]'
})
export class DeltaDragDirective implements OnInit, OnChanges, OnDestroy {
	@Input() deltaDragDisable: boolean;
	@Input() deltaDragNoFilter: boolean;
	@Input() deltaDragStopOnLeave:boolean;

	@Output() cpDeltaDrag = new EventEmitter<DeltaEvent>();
	@Output() cpDeltaDragEnd = new EventEmitter<any>();

	protected mouseDrag: Observable<DeltaEvent>;
	protected mouseDragSubscription: Subscription;

	protected dragEndSub: Subject<any> = new Subject();

	constructor(protected elementRef: ElementRef) { }

	ngOnInit() {
		this.dragEndSub.asObservable().pipe(untilDestroyed(this)).subscribe(x=>{this.cpDeltaDragEnd.emit({})});

		if (
			this.deltaDragDisable ||
			this.mouseDragSubscription // in case ngOnChanges has already ran
		) {
			return;
		}

		this.mouseDrag = this.getMouseDrag();
		this.mouseDragSubscription = this.mouseDrag.pipe(untilDestroyed(this)).subscribe(delta => this.cpDeltaDrag.next(delta));
	}

	ngOnChanges() {
		if (this.deltaDragDisable && this.mouseDragSubscription) {
			this.mouseDragSubscription.unsubscribe();
			this.mouseDragSubscription = null;
		} else if (!this.deltaDragDisable && !this.mouseDragSubscription) {
			this.mouseDrag = this.mouseDrag || this.getMouseDrag();
			this.mouseDragSubscription = this.mouseDrag.pipe(untilDestroyed(this)).subscribe(delta => this.cpDeltaDrag.next(delta));
		}
	}

	ngOnDestroy() {
		if (this.mouseDragSubscription) {
			this.mouseDragSubscription.unsubscribe();
			this.mouseDragSubscription = null;
		}
	}

	protected getMouseDrag() {
		const element = this.elementRef.nativeElement;

		let stopObserable:Observable<any>;
		if (this.deltaDragStopOnLeave){
			let mouseLeabeObs=observableFromEvent(element, 'mouseleave').pipe(debounceTime(100));
			let mouseEnterObs=observableFromEvent(element,'mouseenter');
			let mouseLeaveWithoutReEnter= mouseEnterObs.pipe(switchMap(()=> mouseLeabeObs));//,tap(()=>{console.error('out',element);})
			stopObserable = merge(observableFromEvent(document, 'mouseup'),mouseLeaveWithoutReEnter);
		}else {
			stopObserable=observableFromEvent(document, 'mouseup');
		}
		const mouseMove = observableFromEvent(document, 'mousemove');
		const mouseDown = observableFromEvent(element, 'mousedown');


		return mouseDown.pipe(
			// filter out when the user clicked on the scrollbar (IE bug - mouseup not triggered)
			filter((e:any) => this.deltaDragNoFilter || e.offsetX <= e.target.clientWidth),
			filter((e:any) => this.deltaDragNoFilter || e.offsetY <= e.target.clientHeight),
			mergeMap((mouseDownEvent: MouseEvent) => {
				const startX = mouseDownEvent.clientX, startY = mouseDownEvent.clientY;
				let prevX = mouseDownEvent.clientX, prevY = mouseDownEvent.clientY;
				let isFirst = true;

				mouseDownEvent.preventDefault();
				mouseDownEvent.stopPropagation();

				return mouseMove.pipe(map((mouseMoveEvent: MouseEvent) => {
					mouseMoveEvent.preventDefault();

					const deltaEvent = {
						left: mouseMoveEvent.clientX - startX,
						top: mouseMoveEvent.clientY - startY,
						offsetLeft: mouseMoveEvent.clientX - prevX,
						offsetTop: mouseMoveEvent.clientY - prevY,
						isFirst
					};

					isFirst = false;
					prevX = mouseMoveEvent.clientX;
					prevY = mouseMoveEvent.clientY;

					return deltaEvent;
				}),takeUntil(stopObserable.pipe(tap(()=>{this.dragEndSub.next({});}))));
			}),);
	}
}
